import { EntityDoc4det } from "../../entity/EntityDoc4det";

export class DtoDoc4detsDeleteRes extends EntityDoc4det {
  public message: string | null = null;
}
